import Cooperation from './index.vue';
export default {
  path: '/cooperation',
  name: 'cooperation',
  component: Cooperation,
  meta: {
    name: ''
  }
};
